import React, { useEffect, useState } from 'react';
import { GoDotFill } from "react-icons/go";
import { FiGlobe } from "react-icons/fi";
import { FaTwitter } from "react-icons/fa6";
import { MdMoreHoriz } from "react-icons/md";
import { getCollectionDetails, getCollectionDetailsById } from '../../hooks/Collectionhook';
import collectionLogo from "../../assets/img/avatars/avatar_1.png";
import { useNavigate, } from "react-router-dom";
import { listNFTs } from '../../hooks/NFTHook';
import toast from 'react-hot-toast';

const social_media = [
    { icon: <FiGlobe size={23} />, link: "https://example.com" },
    { icon: <FaTwitter size={23} />, link: "https://twitter.com" },
    { icon: <MdMoreHoriz size={23} />, link: "#" }
];

const Chain_Value = [
    { key: "Created", value: 0 },
    { key: "Chain", value: "Ethereum" },
];

const Banner = (props) => {
    const [show, setShow] = useState(false);
    const [collectionDetails, setCollectionDetails] = useState(null);
    const [totalItems, setTotalItems] = useState(0);
    const collectionAddress = props.contractAddress;

    useEffect(() => {
        const fetchCollectionData = async () => {
            try {
                const data = await getCollectionDetails(collectionAddress);
                if (!data || data.status !== 201) {
                    throw new Error(data?.message || 'Failed to fetch collection details');
                }

                Chain_Value[0].value = data.data.createdAt.split('T')[0];
                setCollectionDetails(data.data);

                const params = { contractAddress: data.data.contractAddress };
                const marketData = await listNFTs(params);

                if (!marketData || !marketData.success) {
                    throw new Error(marketData?.message || 'Failed to fetch NFT listings');
                }

                setTotalItems(marketData.total);
            } catch (error) {
                console.error('Error fetching collection data:', error);
                toast.error(error.message || 'Failed to load collection data. Please try again.');
            }
        };

        fetchCollectionData();
    }, [collectionAddress]);

    const handleError = (event) => {
        event.target.src = collectionLogo;
    };

    // Hooks must be called inside the functional component
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1)
    };
    console.log("Collection Details", collectionDetails, collectionAddress);

    return (
        <div className='banner'>
            <div className='banner_part'>
                <video autoPlay muted loop playsInline>
                    <source src="https://stream.mux.com/gWNXuJ01EMYV01HvRh1I3dXu02zYH3qDqTMuzaU7r2XtTA/high.mp4" type="video/mp4" />
                </video>
            </div>
            <div className="row collection_Details">

                <div className="banner_collection col-lg-6 col-sm-12" >
                    <button
                        onClick={handleBackClick}
                        className="btn btn-white btn-sm my-40 ml-4"
                    >
                        Back
                    </button>

                    <div className="banner_collection_Data">
                        <div className="logo space-y-20" style={{ display: "flex", gap: "20px", justifyContent: "space-around" }}>
                            {collectionDetails === null ? (
                                <img src="https://i.seadn.io/s/raw/files/04806b9bfa9bddb6e0fd147285675639.gif?auto=format&amp;dpr=1&amp;w=3840" alt="" />
                            ) : (
                                <img src={`${collectionDetails.logo}`} onError={handleError} />
                            )}
                            <h1 className='color_white' style={{ whiteSpace: "nowrap", textTransform: "capitalize" }}>
                                {collectionDetails !== null ? collectionDetails.name : "Collection Name"}
                            </h1>
                        </div>

                        <div className="mining_button" >
                            <div className="gif">
                                <GoDotFill color="#68f2ab" />
                            </div>
                            <div className="text">Minting</div>
                            <div className='collection_name_social d-flex align-items-center justify-content-start' style={{ marginLeft: "40px" }}>
                                <div className="collection_social">
                                    {social_media.map((social, index) => (
                                        <div key={index} className='social_icon'>
                                            <a href={social.link} target="_blank" rel="noopener noreferrer">
                                                {social.icon}
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {show ? (
                            <>
                                <pre className="collection_pre_desc" style={{ whiteSpace: 'pre-line' }}>
                                    {collectionDetails?.description}
                                </pre>
                                <span className='pre_show' onClick={() => setShow(false)}>Show Less</span>
                            </>
                        ) : (
                            <>
                                <pre className="collection_pre_desc_0" style={{ whiteSpace: 'pre-line' }}>
                                    {collectionDetails?.description.trim().substring(0, 65)}...
                                    <span className='pre_show' onClick={() => setShow(true)}>Show More</span>
                                </pre>
                            </>
                        )}


                        <div className="collection_chain_value">
                            <div className='text-center chain_value m-10' style={{ whiteSpace: "nowrap" }}>
                                <span className='chain_value_key'>{totalItems} </span>
                                <span className='chain_value_value'>{"Items"}</span>
                            </div>
                            {Chain_Value.map((data, index) => (
                                <div key={index} className='m-10'>
                                    <div className='text-center chain_value' style={{ whiteSpace: "nowrap" }}>
                                        <span className='chain_value_key'>{data.key} </span>
                                        <span className='chain_value_value'>{data.value}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
